module.exports = __webpack_public_path__ + "static/BuenosAiresWeb-Regular-3b41f92c4e5938763e02f84ea611bc6f.woff";